import cc from 'classcat';
import { useRef, useState, useEffect } from 'react';
import { PencilIcon } from '@ui/kit/icons';
import { useComponentEntry } from '@utils/component-framework';
import { useChangeInputEntryMutation } from '../../../state/mutations/entries/change.input.js';
import '@i-ark/models';
import '@tanstack/react-query';
import { selectItemInputEntryById } from '../../../state/selectors/entry.item-input-by-id.js';
import { selectItemInputEntryExists } from '../../../state/selectors/entry.item-input-exists.js';
import { iArkStore } from '../../../state/store.js';
import { inputCls, placeholderCls, placeholderIconCls, containerCls } from './SimpleInput.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const SimpleInput = ({
  pageId,
  item
}) => {
  const placeholderRef = useRef(null);
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const changeInputEntryMutation = useChangeInputEntryMutation(entryKey);
  const itemEntry = useComponentEntry(entryKey, {
    select: selectItemInputEntryById(pageId, item.id)
  });
  const itemEntryExists = useComponentEntry(entryKey, {
    select: selectItemInputEntryExists(pageId, item.id)
  });

  // We keep a local copy of the item entry value which will be updated on
  // keystrokes to avoid issues with async (optimistic) updates from tanstack
  // query, which otherwise will cause the caret to jump to the end of the
  // input.
  const [localItemEntryValue, setLocalItemEntryValue] = useState(itemEntry.data?.value);
  const value = item.settings.usePlaceholderAsDefaultValue === true && !itemEntryExists.data && !localItemEntryValue ? item.placeholder.replace(/\n/g, "<br />") : localItemEntryValue;
  const handleChange = evt => {
    const placeholder = placeholderRef.current;
    if (placeholder === null || placeholder.parentElement === null) {
      return;
    }
    placeholder.innerText = evt.target.value;

    // bail out if new text doesn't fit within the input
    if (placeholder.clientWidth > placeholder.parentElement.clientWidth) {
      return;
    }
    setLocalItemEntryValue(evt.target.value);
    changeInputEntryMutation({
      pageId,
      itemId: item.id,
      value: evt.target.value
    });
  };
  useEffect(() => {
    setLocalItemEntryValue(itemEntry.data?.value);
  }, [itemEntry.data?.value]);
  const placeholder = item.settings.usePlaceholderAsDefaultValue !== true ? item.placeholder : "";
  return /*#__PURE__*/jsxs("div", {
    className: cc([containerCls, {
      usePlaceholderAsDefaultValue: item.settings.usePlaceholderAsDefaultValue,
      showPencil: item.settings.usePlaceholderAsDefaultValue ? !itemEntryExists.data || (value ?? "").length === 0 : (value ?? "").length === 0
    }]),
    children: [/*#__PURE__*/jsx("span", {
      ref: placeholderRef,
      className: cc([inputCls, placeholderCls])
    }), /*#__PURE__*/jsx(PencilIcon, {
      className: cc([placeholderIconCls, "pencil"])
    }), /*#__PURE__*/jsx("input", {
      className: inputCls,
      type: "text",
      placeholder: placeholder,
      maxLength: item.maxLength,
      value: value ?? "",
      onChange: handleChange
    })]
  });
};

export { SimpleInput };
//# sourceMappingURL=SimpleInput.js.map
